import React from "react"
import {Button, Grid, Item, Segment} from "semantic-ui-react"
import MFR from "../../presentation/MFR"
import api from "../../api"
import {TitleBlock} from "../HomePage"
import _ from "lodash"
import {useTranslation} from 'react-i18next'

const OrderSummary = ({order, children}) => {
    let steps = api.getSteps()
    let stepReports = _.map(steps, (step, key) => {
        return <StepReport key={key}
                           step={step}/>
    })
    let appointment = api.getAppointment()
    const {t} = useTranslation()

    return (
        <Segment.Group className="page-padding">
            <TitleBlock order={order}
                        event={appointment}/>
            {order.Description ? <Segment className="order-description"
                                          dangerouslySetInnerHTML={{__html: order.Description}}/> : null}
            {children}
            <Segment>
                <div className="pb3">
                    <Grid stretched columns={2}>
                        <Grid.Column>
                            <div className="f3 strong pt2 pb2">{t("general.report")}</div>
                        </Grid.Column>
                        <Grid.Column className="tr">
                            <Button compact basic>{api.getFinishedSteps()}/{api.getSteps().length}</Button>
                        </Grid.Column>
                    </Grid>
                </div>
                {stepReports}
                {(order.Documents.length > 0) ? <Segment>
                    <MFR.Title className="pb2">{t("general.attachments")}</MFR.Title>
                    <DocGroup attachments={order.Documents}/>
                </Segment> : null}
            </Segment>
        </Segment.Group>
    )
}

const StepReport = ({step}) => {
    let resultString = step.VisibleResult
    if (resultString === "No result") resultString = ""
    if (resultString === "To be done") resultString = ""
    let formated = resultString.split(",").join("<br/>")

    const {t} = useTranslation()

    return (
        <Segment vertical>
            <div className="fr">
                {step.IsDone ? <Button compact color='green' circular icon="checkmark"/> : null}
                {!step.IsDone ? <span className="black-40 f6">{t("general.noInput")}</span> : null}
                {step.hasError ? <Button compact color='red'>{t("enumeration.rework")}</Button> : null}
            </div>
            <div className="f4 strong"
                 title={step.Id}>{step.Name}</div>
            <div dangerouslySetInnerHTML={{__html: formated}}/>

            <DocGroup attachments={step.Attachments}/>
            {/*<pre>{JSON.stringify(step, null, 2)}</pre>*/}
        </Segment>
    )
}

const DocGroup = ({attachments}) => {
    if (attachments.length < 1) return null
    return (
        <Item.Group className="">
            {_.map(attachments, (doc, key) => {
                // let src = document.URI
                // if (document.ContentType === "application/pdf") {
                //   src = imageDefaultSrc
                // }
                return <MFR.ItemDocument document={doc}  key={key} />
            })}
        </Item.Group>
    )
}

export default OrderSummary



// WEBPACK FOOTER //
// ./src/pages/components/OrderSummary.js